export type UUID = string
export type SortDescending = ''
export type SortAscending = '-'

export enum SortDirection {
  ASC = '-',
  DESC = ''
}

export interface SortParam {
  direction: SortDescending | SortAscending
  by: string
}

export interface FindOptions {
  sort?: SortParam
  search?: string
  /**
   * Number of elements returned in collection per page
   */
  limit?: number
  /**
   * ranking number of the first element in the collection
   */
  offset?: number
}

export interface Resource<Attr> {
  id: UUID
  type: string
  attributes: Attr
}

export interface Response<R> {
  data: R | R[]
  meta?: any
}

export interface CreateResponse<R> extends Response<any> {
  data: R
}

export interface DetailsResponse<R> extends Response<any> {
  data: R
}

export interface PaginateResponseMeta {
  total: number
}

export interface PaginateResponse<R> {
  data: R[]
  meta: PaginateResponseMeta
}
